import { useState, useEffect } from 'react';
import { SettingCard, SettingField, SettingActions, useSettingEditing } from './SettingControls';
import FileUpload from "../../Utils/FileUpload";
import butterflyApi from "../../ButterflyApi";
import Utils from "../../utils";

const HeroSetting = ({ heroNo, setLoading, setLoadingMessage, editing, setEditing }) => {

  const [hero, setHero] = useState()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [birthYear, setBirthYear] = useState()
  const [gender, setGender] = useState('M')
  const [heroImage, setHeroImage] = useState('')
  const [graphicHeroImage, setGraphicHeroImage] = useState('')
  const [updated, setUpdated] = useState(false)


  const load = async () => {
    if (!heroNo) return
    const data = await butterflyApi.getHeroes()
    const hero = data?.items?.filter(_hero => _hero.heroNo == heroNo)?.[0]
    if (!hero) return
    setHero(hero)
    update(hero)
    setUpdated(false)
  }

  const onImageUpload = async (fileInfo) => {
    const url = fileInfo.operationUrls?.[0]?.replace("http://", "https://") || fileInfo.url.replace("http://", "https://")
    setLoadingMessage('이미지 처리 중에는\n 시간이 오래 걸릴 수 있습니다.\n잠시만 기다려 주세요.')
    setLoading(true)
    setTimeout(() => {
      setHeroImage(url)
      setGraphicHeroImage(null)
      setUpdated(true)
      setLoading(false)
      setLoadingMessage('')
    }, 5000)

  }

  const update = (hero) => {
    setFirstName(hero.firstName || '')
    setLastName(hero.lastName || '')
    setBirthYear(hero.birthYear)
    setGender(hero.gender)
    setHeroImage(hero.imageUrl)
    setGraphicHeroImage(hero.graphicImageUrl)
  }

  const onCancel = () => {
    update(hero)
  }

  const onSave = async () => {
    if (!firstName) {
      alert('이름을 입력해 주세요.')
      return
    }
    setLoadingMessage('이미지 처리 중에는\n 시간이 오래 걸릴 수 있습니다.\n잠시만 기다려 주세요.')
    setLoading(true)
    if (hero.imageUrl != heroImage) {
      await butterflyApi.updateHeroImage(
        heroNo, heroImage
      )
    }
    await butterflyApi.updateHero(
      heroNo,
      firstName,
      lastName,
      gender,
      birthYear
    )
    await load()
    localStorage.removeItem("heroes")
    const heroesResponse = await butterflyApi.getHeroes()
    const heroes = heroesResponse.items
    localStorage.setItem("heroes", JSON.stringify(heroes))
    localStorage.setItem("heroNo", hero?.heroNo || heroes[0].heroNo)
    setLoading(false)
    setLoadingMessage('')

  }

  useEffect(() => {
    load();
  }, [heroNo])

  useEffect(() => {
    if (!hero) return;
    if (firstName !== (hero.firstName || '')) {
      setUpdated(true)
      return;
    }
    if (lastName !== (hero.lastName || '')) {
      setUpdated(true)
      return;
    }
    if (gender != hero.gender) {
      setUpdated(true)
      return;
    }
    if (birthYear != hero.birthYear) {
      setUpdated(true)
      return;
    }
    setUpdated(heroImage !== hero.imageUrl)
  }, [firstName, lastName, gender, birthYear, heroImage, hero])

  useSettingEditing(updated, setEditing)

  const birthYears = Array.from({ length: 9 }, (_, i) => new Date().getFullYear() - 2 - i)
  if (birthYear && !birthYears.includes(Number(birthYear))) birthYears.push(Number(birthYear))
  birthYears.sort((a, b) => b - a)

  return <SettingCard label="주인공 정보" updated={updated} disabled={!hero || (editing && !updated)}>
    <div className="setting-photo">
      <img src={graphicHeroImage || heroImage || '/image/no_profile_image.png'} alt="주인공 프로필" />
      <div className="setting-photo-copy">
        <p>얼굴이 잘 보이는<br />아이의 독사진을 올려주세요.<br />이미지 파일 · 최대 10MB</p>
        <FileUpload path="/public/images/temp" filename={Utils.uuidv4()} operations="300" uploaded={onImageUpload} onlyImage={true} setLoading={setLoading} maxSize={10000000} overSizeMessage="10MB 이하의 이미지만 업로드 가능합니다.">
          <button type="button" className="setting-photo-button"><img src="/image/edit.svg" alt="" />{heroImage ? '사진 변경' : '사진 등록'}</button>
        </FileUpload>
      </div>
    </div>
    <div className="setting-fields">
      <SettingField label="성" autoComplete="family-name" value={lastName} placeholder="김" onChange={e => setLastName(e.target.value)} />
      <SettingField label="이름" autoComplete="given-name" value={firstName} placeholder="아이의 이름" onChange={e => setFirstName(e.target.value)} />
    </div>
    <div className="setting-fields">
      <SettingField label="태어난 해" as="select" value={birthYear || ''} onChange={e => setBirthYear(e.target.value)}>
        <option value="">선택</option>
        {birthYears.map(year => <option key={year} value={year}>{year}년</option>)}
      </SettingField>
      <SettingField label="성별" as="select" value={gender || ''} onChange={e => setGender(e.target.value)}>
        <option value="">선택</option><option value="M">남자아이</option><option value="F">여자아이</option>
      </SettingField>
    </div>
    {updated && <SettingActions onSave={onSave} onCancel={onCancel} />}
  </SettingCard>
}

export default HeroSetting
